'use client'

import React from 'react'
import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter
} from "reactstrap"
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import MyEditor from "components/MyEditor";
import { Highlight2Content } from './Highlight2Content';

export const ESG4PlusCard2 = ({ validation, pageView }) => {
    return (
        <Card style={{ backgroundColor: "#e2ffeeff" }}>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
                <i className='bx bx-cube-alt'></i> Nature Positive
            </h5>
            <CardBody>
                <Row>
                    <Col className="col-12 mb-3">
                        <label
                            htmlFor="tab2Title"
                            className="col-md-12 col-form-label"
                        >
                            Title
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <Input
                                id="tab2Title"
                                className="form-control"
                                type="text"
                                placeholder=""
                                name="tab2Title"

                                onChange={(e) => {
                                    validation.setFieldValue("tab2Title", e.target.value)
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab2Title}
                                invalid={validation.touched.tab2Title && validation.errors.tab2Title ? true : false}
                                disabled={pageView === "view"}
                            />
                            {
                                validation.touched.tab2Title && validation.errors.tab2Title && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab2Title}
                                    </FormFeedback>
                                )
                            }
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        {/* {JSON.stringify(validation.values.tab2_icon1)} */}
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab2_icon1"
                                label="Icon1"
                                required={true}
                                description="description"
                                widthSize={48}
                                heightSize={48}
                                value={validation.values.tab2_icon1}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_icon1', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_icon1', {})
                                }}
                            />
                            {validation.touched.tab2_icon1 && validation.errors.tab2_icon1 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab2_icon1}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-6 mb-3">
                        {/* {JSON.stringify(validation.values.tab2_icon2)} */}
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab2_icon2"
                                label="Icon2"
                                required={true}
                                description="description"
                                widthSize={80}
                                heightSize={80}
                                value={validation.values.tab2_icon2}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_icon2', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_icon2', {})
                                }}
                            />
                            {validation.touched.tab2_icon2 && validation.errors.tab2_icon2 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab2_icon2}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    {/* <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="slug"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Slug
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <Input
                                                                            id="slug"
                                                                            className="form-control"
                                                                            type="text"
                                                                            placeholder=""
                                                                            name="slug"

                                                                            onChange={(e) => {
                                                                                validation.setFieldValue("slug", slugify(e.target.value))
                                                                            }}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.slug}
                                                                            invalid={validation.touched.slug && validation.errors.slug ? true : false}
                                                                            disabled={pageView === "view"}
                                                                        />
                                                                        {
                                                                            validation.touched.slug && validation.errors.slug && (
                                                                                <FormFeedback type="invalid">
                                                                                    {validation.errors.slug}
                                                                                </FormFeedback>
                                                                            )
                                                                        }
                                                                    </div>
                                                                    <hr />
                                                                </Col> */}
                    <Col className="col-12 mb-3">
                        <label
                            htmlFor="tab2Detail"
                            className="col-md-12 col-form-label"
                        >
                            Detail
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab2Detail"
                                placeholder=""
                                name="tab2Detail"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab2Detail",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab2Detail}
                                invalid={
                                    validation.touched.tab2Detail &&
                                        validation.errors.tab2Detail
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab2Detail &&
                                validation.errors.tab2Detail && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab2Detail}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-4 mb-3">
                        <label
                            htmlFor="tab2Detail2"
                            className="col-md-12 col-form-label"
                        >
                            Detail2
                            <span className="t-require">*</span>
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab2Detail2"
                                placeholder=""
                                name="tab2Detail2"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab2Detail2",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab2Detail2}
                                invalid={
                                    validation.touched.tab2Detail2 &&
                                        validation.errors.tab2Detail2
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab2Detail2 &&
                                validation.errors.tab2Detail2 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab2Detail2}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-4 mb-3">
                        <label
                            htmlFor="tab2Detail3"
                            className="col-md-12 col-form-label"
                        >
                            Detail3
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab2Detail3"
                                placeholder=""
                                name="tab2Detail3"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab2Detail3",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab2Detail3}
                                invalid={
                                    validation.touched.tab2Detail3 &&
                                        validation.errors.tab2Detail3
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab2Detail3 &&
                                validation.errors.tab2Detail3 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab2Detail3}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-4 mb-3">
                        <label
                            htmlFor="tab2Detail4"
                            className="col-md-12 col-form-label"
                        >
                            Detail4
                        </label>
                        <div className="col-md-12">
                            <MyEditor
                                id="tab2Detail4"
                                placeholder=""
                                name="tab2Detail4"
                                onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                        "tab2Detail4",
                                        data
                                    )
                                    console.log({ e, editor, data })
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab2Detail4}
                                invalid={
                                    validation.touched.tab2Detail4 &&
                                        validation.errors.tab2Detail4
                                        ? true
                                        : false
                                }
                                disabled={pageView === "view"}
                            />
                            {validation.touched.tab2Detail4 &&
                                validation.errors.tab2Detail4 && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab2Detail4}
                                    </FormFeedback>
                                )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-12 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab2_bg"
                                label="Background"
                                required={true}
                                description="description"
                                widthSize={2160}
                                heightSize={618}
                                value={validation.values.tab2_bg}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_bg', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_bg', {})
                                }}
                            />
                            {validation.touched.tab2_bg && validation.errors.tab2_bg && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab2_bg}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-12 mb-3">
                        <label
                            htmlFor="tab2HighlightTitle"
                            className="col-md-12 col-form-label"
                        >
                            Highlight Title
                            {/* <span className="t-require">*</span> */}
                        </label>
                        <div className="col-md-12">
                            <Input
                                id="tab2HighlightTitle"
                                className="form-control"
                                type="text"
                                placeholder=""
                                name="tab2HighlightTitle"

                                onChange={(e) => {
                                    validation.setFieldValue("tab2HighlightTitle", e.target.value)
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab2HighlightTitle}
                                invalid={validation.touched.tab2HighlightTitle && validation.errors.tab2HighlightTitle ? true : false}
                                disabled={pageView === "view"}
                            />
                            {
                                validation.touched.tab2HighlightTitle && validation.errors.tab2HighlightTitle && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab2HighlightTitle}
                                    </FormFeedback>
                                )
                            }
                        </div>
                        <hr />
                    </Col>
                    <Col className="col-12 mb-3">
                        <label
                            htmlFor="tab2LinkUrl"
                            className="col-md-12 col-form-label"
                        >
                            Highlight Link URL
                            {/* <span className="t-require">*</span> */}
                        </label>
                        <div className="col-md-12">
                            <Input
                                id="tab2LinkUrl"
                                className="form-control"
                                type="text"
                                placeholder=""
                                name="tab2LinkUrl"

                                onChange={(e) => {
                                    validation.setFieldValue("tab2LinkUrl", e.target.value)
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.tab2LinkUrl}
                                invalid={validation.touched.tab2LinkUrl && validation.errors.tab2LinkUrl ? true : false}
                                disabled={pageView === "view"}
                            />
                            {
                                validation.touched.tab2LinkUrl && validation.errors.tab2LinkUrl && (
                                    <FormFeedback type="invalid">
                                        {validation.errors.tab2LinkUrl}
                                    </FormFeedback>
                                )
                            }
                        </div>
                        <hr />
                    </Col>

                    {/* <Highlight2Content validation={validation} pageView={pageView} /> */}

                    {/* <Col className="col-12 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab2_section_image1"
                                label="Section Image1"
                                required={true}
                                description="description"
                                widthSize={888}
                                heightSize={599}
                                value={validation.values.tab2_section_image1}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_section_image1', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_section_image1', {})
                                }}
                            />
                            {validation.touched.tab2_section_image1 && validation.errors.tab2_section_image1 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab2_section_image1}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col> */}

                    {/* <Col className="col-6 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab2_card_image1"
                                label="Card Image1"
                                required={true}
                                description="description"
                                widthSize={576}
                                heightSize={720}
                                value={validation.values.tab2_card_image1}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_card_image1', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_card_image1', {})
                                }}
                            />
                            {validation.touched.tab2_card_image1 && validation.errors.tab2_card_image1 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab2_card_image1}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col> */}
                    {/* <Col className="col-6 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab2_card_image2"
                                label="Card Image2"
                                required={true}
                                description="description"
                                widthSize={576}
                                heightSize={720}
                                value={validation.values.tab2_card_image2}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_card_image2', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_card_image2', {})
                                }}
                            />
                            {validation.touched.tab2_card_image2 && validation.errors.tab2_card_image2 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab2_card_image2}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col> */}
                    {/* <Col className="col-6 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab2_card_image3"
                                label="Card Image2"
                                required={true}
                                description="description"
                                widthSize={576}
                                heightSize={720}
                                value={validation.values.tab2_card_image3}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_card_image3', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_card_image3', {})
                                }}
                            />
                            {validation.touched.tab2_card_image3 && validation.errors.tab2_card_image3 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab2_card_image3}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col> */}
                    {/* <Col className="col-6 mb-3">
                        <div className="col-md-12">
                            <PopupAttachment
                                typeDetail="single"
                                typeUpload="ImageMap"
                                upload="Image"
                                prefixName="tab2_card_image4"
                                label="Card Image2"
                                required={true}
                                description="description"
                                widthSize={576}
                                heightSize={720}
                                value={validation.values.tab2_card_image4}
                                onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_card_image4', value)
                                }}
                                onRemove={(index) => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue('tab2_card_image4', {})
                                }}
                            />
                            {validation.touched.tab2_card_image4 && validation.errors.tab2_card_image4 && (
                                <div type="invalid" className="invalid-feedback d-block">
                                    {validation.errors.tab2_card_image4}
                                </div>
                            )}
                        </div>
                        <hr />
                    </Col> */}
                </Row>
            </CardBody>
        </Card>

    )
}